/**
 * FCT Account API
 * FCT Account API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: areche@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import Regulations from './Regulations';

/**
 * The ProtoDocumentMetadata model module.
 * @module model/ProtoDocumentMetadata
 * @version 1.0.0
 */
class ProtoDocumentMetadata {
    /**
     * Constructs a new <code>ProtoDocumentMetadata</code>.
     * @alias module:model/ProtoDocumentMetadata
     */
    constructor() { 
        
        ProtoDocumentMetadata.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ProtoDocumentMetadata</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ProtoDocumentMetadata} obj Optional instance to populate.
     * @return {module:model/ProtoDocumentMetadata} The populated <code>ProtoDocumentMetadata</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ProtoDocumentMetadata();

            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'Number');
            }
            if (data.hasOwnProperty('check')) {
                obj['check'] = ApiClient.convertToType(data['check'], 'Boolean');
            }
            if (data.hasOwnProperty('percent')) {
                obj['percent'] = ApiClient.convertToType(data['percent'], 'Number');
            }
            if (data.hasOwnProperty('type')) {
                obj['type'] = ApiClient.convertToType(data['type'], 'String');
            }
            if (data.hasOwnProperty('contributed_days_100')) {
                obj['contributed_days_100'] = ApiClient.convertToType(data['contributed_days_100'], 'Number');
            }
            if (data.hasOwnProperty('regulations')) {
                obj['regulations'] = Regulations.constructFromObject(data['regulations']);
            }
        }
        return obj;
    }


}

/**
 * Status of the precontract
 * @member {Number} status
 */
ProtoDocumentMetadata.prototype['status'] = undefined;

/**
 * Valor del check
 * @member {Boolean} check
 */
ProtoDocumentMetadata.prototype['check'] = undefined;

/**
 * Percent
 * @member {Number} percent
 */
ProtoDocumentMetadata.prototype['percent'] = undefined;

/**
 * Tipo de exención (freelance, etc.)
 * @member {String} type
 */
ProtoDocumentMetadata.prototype['type'] = undefined;

/**
 * numero horas minimas
 * @member {Number} contributed_days_100
 */
ProtoDocumentMetadata.prototype['contributed_days_100'] = undefined;

/**
 * @member {module:model/Regulations} regulations
 */
ProtoDocumentMetadata.prototype['regulations'] = undefined;






export default ProtoDocumentMetadata;

